<template>
  <div class="main-wrapper">
    <div class="login-page">
      <div class="login-body container">
        <div class="loginbox" style="padding-bottom: 0px">
          <div class="login-right-wrap">
            <div class="account-header">
              <div class="account-logo text-center mb-4">
                <router-link to="/">
                  <!--									<img src="@/assets/img/easy-retail-logo.png" alt="" class="img-fluid">-->
                  <a href="/" class="text-lg" style="font-size: 26px">
                    <span
                      class="font-weight-600 text-slate-300"
                      :style="logoPrefixStyle"
                    >
                      {{ branding.logo.prefix }}
                    </span>
                    <span
                      class="font-weight-bold text-slate-500"
                      :style="logoSuffixStyle"
                    >
                      {{ branding.logo.suffix }}
                    </span>
                  </a>
                </router-link>
              </div>
            </div>
            <div class="login-header text-center">
              <h6 class="text-muted">{{ branding.loginTitle }}</h6>
              <div class="mt-4">
                <div
                  v-if="success === true && message"
                  class="alert alert-success"
                  role="alert"
                >
                  <strong>Success!</strong> {{ message }}
                </div>
                <div
                  v-if="success === 'info' && message"
                  class="alert alert-info"
                  role="alert"
                >
                  {{ message }}
                </div>
                <div
                  v-if="success === false && message"
                  class="alert alert-danger"
                  role="alert"
                >
                  {{ message }}
                </div>
              </div>
            </div>
            <form class="vld-parent" ref="formContainer">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="user.username"
                  required
                  v-model="user.username"
                  name="user.username"
                  placeholder="Enter your email"
                />
              </div>
              <div class="form-group mb-4" style="position: relative;">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control"
                  id="user.password"
                  required
                  v-model="user.password"
                  name="user.password"
                  placeholder="Enter your password"
                  autocomplete="off"
                />
                <button
                  class="btn"
                  style="position: absolute; top: 0; right: 0; margin-top: 2% !important;"
                  type="button"
                  @click="togglePassword($event)"
                >
                  <i v-if="showPassword" class="fa fa-eye mr-1"></i>
                  <i v-else class="fa fa-eye-slash mr-1"></i>
                </button>
              </div>
              <div class="text-center">
                <button
                  class="btn btn-primary btn-block account-btn"
                  type="button"
                  @click="login()"
                  :style="{
                    backgroundColor: branding.buttonColor,
                    color: branding.buttonTextColor,
                    borderColor: branding.buttonColor
                  }"
                  :disabled="loading"
                >
                  <span v-if="!loading">Login</span>
                  <span v-else>
                    <i
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></i>
                  </span>
                </button>
                <button
                  v-if="branding.showSignUp"
                  class="btn btn-primary btn-block account-btn mt-2"
                  type="button"
                  @click="register()"
                  :style="{
                    backgroundColor: 'white',
                    color: branding.buttonColor,
                    borderColor: branding.buttonColor
                  }"
                >
                  Sign Up
                </button>
              </div>
            </form>

            <div class="text-center forgotpass mt-4 text-muted">
              Forgot Password?
              <router-link
                to="/forgot-password"
                :style="{ color: branding.primaryColor, fontWeight: '600' }"
              >
                Reset
              </router-link>
            </div>

            <div class="text-center mt-3">
              <span class="text-muted">Have an invitation code? </span>
              <router-link
                to="/join-business"
                :style="{ color: branding.primaryColor, fontWeight: '600' }"
              >
                Enter Code
              </router-link>
            </div>
            <!--								<div class="login-or">-->
            <!--									<span class="or-line"></span>-->
            <!--									<span class="span-or">or</span>-->
            <!--								</div>-->

            <!--								&lt;!&ndash; Social Login &ndash;&gt;-->
            <!--								<div class="social-login">-->
            <!--									<span>Login with</span>-->
            <!--									<a href="#" class="facebook"><i class="fab fa-facebook-f"></i></a><a href="#" class="google"><i class="fab fa-google"></i></a>-->
            <!--								</div>-->
            <!--								&lt;!&ndash; /Social Login &ndash;&gt;-->

            <div
              class="text-center dont-have mb-4"
              style="margin-top: 1rem !important;"
            >
              <div>
                Didn't receive verification code?
                <router-link
                  to="/register/resend-code"
                  :style="{ color: branding.primaryColor }"
                >
                  Resend
                </router-link>
              </div>
              <div class="mt-3">
                <small id="terms-footnote" class="footnote">
                  {{ branding.footerText }}
                  <a
                    :href="branding.privacyPolicyUrl"
                    target="_blank"
                    :style="{ color: branding.primaryColor }"
                  >
                    privacy policy
                  </a>
                  and
                  <a
                    :href="branding.termsUrl"
                    target="_blank"
                    :style="{ color: branding.primaryColor }"
                  >
                    terms and conditions
                  </a>
                  that govern your usage of our services.
                </small>
                <small
                  style="color: purple !important; text-decoration: underline"
                  hidden
                >
                  <a href="javascript:void(0);" @click="goToActivateLicense">
                    Activate license
                  </a>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBrandingByDomain } from "@/config/domainBranding";
import authServiceApi from "../../service/AuthServiceApi";

export default {
  name: "login",
  data() {
    return {
      success: null,
      message: "",
      user: {
        username: null,
        password: null
      },
      loading: false,
      token: null,
      fullPage: false,
      showPassword: false,
      branding: getBrandingByDomain(location.host)
    };
  },
  computed: {
    resetMessage(e) {
      this.message = "";
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    logoSuffixStyle() {
      return {
        color: this.branding.logo.suffixColor || "#ffffff",
        fontWeight: "bold",
        backgroundColor:
          this.branding.logo.suffixBackgroundColor ||
          this.branding.primaryColor,
        padding: "6px",
        borderRadius: "5px"
      };
    },
    logoPrefixStyle() {
      return {
        color: this.branding.logo.prefixColor || this.branding.secondaryColor
      };
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push(localStorage.getItem("homeUrl"));
    }
  },
  methods: {
    togglePassword(e) {
      e.preventDefault();
      this.showPassword = !this.showPassword;
    },
    register() {
      this.$router.push("/register");
    },
    goToActivateLicense() {
      this.$router.push("/license");
    },
    async login() {
      if (!this.user.username) {
        this.success = false;
        this.message = "Username is required";
        return;
      }
      if (!this.user.password) {
        this.success = false;
        this.message = "Password is required";
        return;
      }
      let data = {
        username: this.user.username,
        password: this.user.password,
        domain: location.host,
        industryType:
          this.$i18n.locale === "levies" ? "LEVIES" : this.$i18n.locale
      };
      this.loading = true;
      await authServiceApi
        .login(data)
        .then(async response => {
          let success = response.data.success;
          if (success) {
            const userData = response.data.data;

            // Validate that user has CUSTOMER_CONTACT contexts
            if (
              !userData.availableContexts ||
              !userData.availableContexts.length
            ) {
              this.success = false;
              this.message = "No contexts available for this account";
              return;
            }

            const hasCustomerContext = userData.availableContexts.some(
              context => context.actorType === "CUSTOMER_CONTACT"
            );

            if (!hasCustomerContext) {
              this.success = false;
              this.message =
                "This portal is only accessible to customer contacts. Please use the admin portal.";
              return;
            }

            await localStorage.setItem("user", JSON.stringify(userData));
            await this.$store.dispatch("auth/setLoginSuccess", this.user);
            await this.$router.push("/select-business");
          } else {
            this.success = false;
            this.message = response.data.narrative;
          }
        })
        .catch(e => {
          console.log("Error: ", e);
          if (e.response && e.response.status) {
            if (
              e.response.status === 400 ||
              e.response.status === 401 ||
              e.response.status === 403 ||
              e.response.status === 409
            ) {
              this.success = false;
              this.message = e.response.data.narrative || "Failed to login";
              return;
            }
          }
          this.success = false;
          this.message = "Sorry, we can not login you in at this time.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fireNotification(icon, title, message) {
      Swal.fire({
        icon: icon,
        title: title,
        text: message,
        footer: '<a href="">Need help?</a>'
      });
    }
  },
  mounted() {
    const message = this.$route.query.message;
    const invitationId = this.$route.query.invitationId;
    const successParam = this.$route.query.success;
    if (message) {
      // Determine message type based on query params
      if (successParam === "true") {
        this.success = true; // Green success alert
      } else if (invitationId) {
        this.success = "info"; // Blue info alert
      } else {
        this.success = false; // Red error alert
      }
      this.message = message;
      return;
    }

    if (
      this.$store.state.app.verificationMessage &&
      this.$store.state.app.verificationMessage.success
    ) {
      this.success = this.$store.state.app.verificationMessage.success;
      this.message = this.$store.state.app.verificationMessage.message;
      this.$store.dispatch("app/clearVerificationMessage");
    }
  }
};
</script>

<style scoped>
.spinner-border {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: text-bottom;
  border: 0.1em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue